import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Sidebar from "@/components/Sidebar";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";

export default function AdminSubscriptions() {
  const [plans, setPlans] = useState([]);
  const [payments, setPayments] = useState([]);

  const load = async () => {
    const [p, pay] = await Promise.all([api.get("/admin/plans"), api.get("/admin/payments")]);
    setPlans(p.data);
    setPayments(pay.data);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (plan) => {
    await api.put(`/admin/plans/${plan.id}`, { active: !plan.active });
    toast.success(`Plan ${plan.active ? "disabled" : "enabled"}`);
    load();
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar role="admin" />
      <main className="flex-1 bg-[#FCFCFC] p-8 lg:p-12">
        <div className="max-w-6xl">
          <div className="overline">Billing</div>
          <h1 className="font-editorial text-4xl mt-2">Subscription Management</h1>

          <div className="mt-8">
            <div className="overline mb-3">Plans</div>
            <div className="grid md:grid-cols-2 gap-4">
              {plans.map((p) => (
                <div key={p.id} className="bg-white border border-border rounded p-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <div className="font-editorial text-2xl">{p.name}</div>
                      <div className="text-sm text-slate-500">{p.currency} {p.price.toLocaleString()} / {p.duration_days} days</div>
                    </div>
                    <button data-testid={`plan-toggle-${p.id}`} onClick={()=>toggle(p)}
                      className={`text-xs uppercase tracking-widest px-3 py-1.5 rounded border ${p.active ? "border-emerald-500 text-emerald-700" : "border-slate-300 text-slate-500"}`}>
                      {p.active ? "Active" : "Disabled"}
                    </button>
                  </div>
                  <ul className="mt-3 text-sm text-slate-600 space-y-1">
                    {(p.features || []).map((f, i) => <li key={i}>• {f}</li>)}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12">
            <div className="overline mb-3">Payment History</div>
            <div className="bg-white border border-border rounded overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
                  <tr>
                    <th className="text-left px-6 py-3">Session</th>
                    <th className="text-left px-6 py-3">User</th>
                    <th className="text-left px-6 py-3">Amount</th>
                    <th className="text-left px-6 py-3">Status</th>
                    <th className="text-left px-6 py-3">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-400">No transactions yet.</td></tr>}
                  {payments.map((p) => (
                    <tr key={p.id} className="border-t border-border">
                      <td className="px-6 py-3 font-mono-e text-[11px] max-w-[160px] truncate">{p.session_id}</td>
                      <td className="px-6 py-3 text-xs">{p.user_id?.slice(0,8)}…</td>
                      <td className="px-6 py-3">{p.currency?.toUpperCase()} {Number(p.amount).toLocaleString()}</td>
                      <td className="px-6 py-3"><span className={`text-xs px-2 py-0.5 rounded border ${p.payment_status === "paid" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-700 border-amber-200"}`}>{p.payment_status}</span></td>
                      <td className="px-6 py-3 text-xs text-slate-500">{new Date(p.created_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
